import React, { useEffect, useState } from "react";
import { Input, Card, Checkbox, Button, Tooltip, Icon, message, Select } from "antd";
import { Translate } from "react-translated";
import { ADD_EMAIL_TEMPLATE, DELETE_EMAIL_TEMPLATE } from "../../utils/Api_enums";
import axios from "../../api";
import F from "../../Functions";
import { PLEASE_FILL_ALL_REQUIRED_FIELD, PLEASE_FILL_BOTH_LINK_TITLE_AND_URL_IN_ROW, PLEASE_FILL_TEMPLATE_BODY, PLEASE_FILL_TEMPLATE_SUBJECT, PLEASE_FILL_TEMPLATE_TITLE, PLEASE_SELECT_AT_LEAST_ONE_CARRIER } from "../../utils/Constants";

const { TextArea } = Input;
const { Option } = Select

const AddTemplate = (props) => {
    const prefilledData = props.location.state || {};
    const [carriers] = useState(F.getCarriers().filter(c => c.id !== 'All Carrier'));


    useEffect(() => {
        if (props.location.state == 'Add') {
        }
        else if (!props.location.state) {
            props.history.replace("/template/email-template");
        }
    }, []);

    const [template, setTemplate] = useState({
        id: prefilledData.id || null,
        title: prefilledData.title || "",
        subject: prefilledData.subject || "",
        body: prefilledData.body || "",
        external_rac_link_title: prefilledData.external_rac_link_title || prefilledData.external_rac_link_title || "",
        links: (prefilledData.content_urls
            ? prefilledData.content_urls.map(link => ({
                title: link.link_title || "",
                url: link.link_url || ""
            }))
            : [{ title: "", url: "" }]),
        agency_owner: typeof prefilledData.agency_owner === 'boolean' ? prefilledData.agency_owner : true,
        agency_staff: typeof prefilledData.agency_staff === 'boolean' ? prefilledData.agency_staff : true,
        carrier_ids: prefilledData.carrier_ids || []
    });

    const updateField = (key, value) => {
        setTemplate({ ...template, [key]: value });
    };

    const updateLink = (index, field, value) => {
        const updated = [...template.links];
        updated[index][field] = value;
        setTemplate({ ...template, links: updated });
    };

    const addRow = () => {
        setTemplate({
            ...template,
            links: [...template.links, { title: "", url: "" }]
        });
    };

    const removeRow = (index) => {
        if (index === 0) {
            const updated = [...template.links];
            updated[0] = { title: "", url: "" };

            setTemplate({
                ...template,
                links: updated
            });

            return;
        }


        const updated = template.links.filter((_, i) => i !== index);

        setTemplate({
            ...template,
            links: updated
        });
    };


    const isAllSelected = carriers.length > 0 && template.carrier_ids.length === carriers.length;

    const handleSelectAll = () => {
        if (isAllSelected) {
            updateField("carrier_ids", []);
        } else {
            updateField("carrier_ids", carriers.map(c => c.id));
        }
    };



    const handleSaveTemplate = (templateData) => {
        if (
            !templateData.title.trim() &&
            !templateData.subject.trim() &&
            !templateData.body.trim()
        ) {
            message.error(PLEASE_FILL_ALL_REQUIRED_FIELD);
            return;
        } else if (!templateData.title.trim()) {
            message.error(PLEASE_FILL_TEMPLATE_TITLE);
            return;
        } else if (!templateData.subject.trim()) {
            message.error(PLEASE_FILL_TEMPLATE_SUBJECT);
            return;
        } else if (!templateData.body.trim()) {
            message.error(PLEASE_FILL_TEMPLATE_BODY);
            return;
        } else if (templateData.carrier_ids.length === 0) {
            message.error(PLEASE_SELECT_AT_LEAST_ONE_CARRIER);
            return;
        }




        for (let i = 0; i < templateData.links.length; i++) {
            const link = templateData.links[i];

            const titleFilled = link.title && link.title.trim() !== "";
            const urlFilled = link.url && link.url.trim() !== "";

            if ((titleFilled && !urlFilled) || (!titleFilled && urlFilled)) {
                message.error(`${PLEASE_FILL_BOTH_LINK_TITLE_AND_URL_IN_ROW} ${i + 1}`);
                return;
            }
        }

        const payload = {
            id: templateData.id || undefined,
            title: templateData.title,
            subject: templateData.subject,
            body: templateData.body,
            external_rac_link_title: templateData.external_rac_link_title || null,
            agency_owner: templateData.agency_owner,
            agency_staff: templateData.agency_staff,
            content_urls: templateData.links.map(link => ({
                link_title: '',
                link_url: ''
            })),
            carrier_ids: templateData.carrier_ids,
        };

        console.log("API PAYLOAD ", payload);

        axios
            .post(ADD_EMAIL_TEMPLATE, payload)
            .then(() => {
                message.success(
                    templateData.id
                        ? "Template updated successfully!"
                        : "Template saved successfully!"
                );
                props.history.push("/template/email-template");
            })
            .catch((err) => {
                message.error("Failed to save template. Please try again.");
                console.error("API ERROR 👉", err);
            });
    };







    return (
        <Card>
            <div className="inputFieldEmailTemplate">
                <label>
                    <Translate text="Template Title" /> <span className="required-symbol">*</span>
                </label>
                <Input
                    value={template.title || ""}
                    onChange={(e) => updateField("title", e.target.value)}
                    maxLength={100}
                    placeholder="Enter template title"
                />
            </div>

            <div className="inputFieldEmailTemplate">
                <label>
                    <Translate text="Email Subject" /> <span className="required-symbol">*</span>
                </label>
                <Input
                    value={template.subject || ""}
                    onChange={(e) => updateField("subject", e.target.value)}
                    maxLength={150}
                    placeholder="Enter email subject"
                />
            </div>

            <div className="inputFieldEmailTemplate">
                <label>
                    <Translate text="Email Body" /> <span className="required-symbol">*</span>
                </label>
                <TextArea
                    rows={6}
                    value={template.body || ""}
                    onChange={(e) => updateField("body", e.target.value)}
                    placeholder="Write email content here..."
                />
            </div>




            {/* External B File Creation Link */}
            <div className="inputFieldEmailTemplate">
                <label>
                    <Translate text="Add External B File Creation Link" />
                </label>
                <div className="linkRow">
                    <Input
                        placeholder="Link Title"
                        className="linkTitleInput"
                        value={template.external_rac_link_title || ""}
                        onChange={(e) => updateField("external_rac_link_title", e.target.value)}
                    />
                    <Tooltip title="The External B File Creation Link will be embedded for each agency under this title.">
                        <Icon type="info-circle" className="info-icon" style={{ color: '#3F85F0' }} />
                    </Tooltip>
                </div>
            </div>

            {/* Add Links */}
            {/* <div className="inputFieldEmailTemplate">
                <label>
                    <Translate text="Additional Links" />
                </label>

                {template.links.map((link, index) => (
                    <div className="linkRow" key={index}>
                        <strong className="linkIndex">{index + 1}.</strong>

                        <Input
                            placeholder="Link Title"
                            value={link.title || ""}
                            onChange={(e) => updateLink(index, "title", e.target.value)}
                            className="linkInput"
                        />

                        <Input
                            placeholder="Link URL"
                            value={link.url || ""}
                            onChange={(e) => updateLink(index, "url", e.target.value)}
                            className="linkInput"
                        />

                        <Button
                            type="danger"
                            shape="circle"
                            icon="cross"
                            onClick={() => removeRow(index)}
                            // disabled={template.links.length === 1}
                        />
                    </div>
                ))}


                <div className="addRowWrapper">
                    <Button onClick={addRow} className="addRowBtn borderRadius-28">
                        <Icon type="plus" /> Add Row
                    </Button>
                </div>
            </div> */}


            {/* Select Carrier */}
            <div className="inputFieldEmailTemplate">
                <label>
                    <Translate text="Select Carrier" />
                    <span className="required-symbol">*</span>
                </label>
                <Select
                    mode="multiple"
                    placeholder="Select Carrier"
                    value={template.carrier_ids}
                    onChange={(val) => updateField("carrier_ids", val)}
                    style={{ width: "100%" }}
                    dropdownRender={(menu) => (
                        <div>
                            <div
                                style={{
                                    padding: "8px 12px",
                                    cursor: "pointer",
                                    borderBottom: "1px solid #e8e8e8",
                                    fontWeight: 600
                                }}
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={handleSelectAll}
                            >
                                <Checkbox checked={isAllSelected}>
                                    Select All
                                </Checkbox>
                            </div>
                            {menu}
                        </div>
                    )}
                >
                    {carriers.map((carrier) => (
                        <Option key={carrier.id} value={carrier.id}>
                            {carrier.name}
                        </Option>
                    ))}
                </Select>
            </div>


            {/* Visibility */}
            <div className="inputFieldEmailTemplate inlineField">
                <label>
                    <Translate text="Visible to" />
                </label>

                <div className="checkboxRow">
                    <Checkbox
                        checked={template.agency_owner}
                        onChange={(e) =>
                            updateField("agency_owner", e.target.checked)
                        }
                    >
                        Agency Owner
                    </Checkbox>

                    <Checkbox
                        checked={template.agency_staff}
                        onChange={(e) =>
                            updateField("agency_staff", e.target.checked)
                        }
                    >
                        Agency Staff
                    </Checkbox>
                </div>
            </div>


            {/* Save Button */}
            <div className="formActions">
                <Button
                    type="primary"
                    className="bg-164897 borderRadius-28"
                    onClick={() => {
                        handleSaveTemplate(template);
                    }}
                >
                    <Icon type="save" /> Save
                </Button>
            </div>
        </Card>
    );
};

export default AddTemplate;



// WEBPACK FOOTER //
// ./src/scenes/SuperAdmin/add_template.js